// Rótulos pt-BR para os ENUMs do domínio + helpers de formatação.

export const MUSCLE_GROUPS = [
  'peito', 'costas', 'ombro', 'biceps', 'triceps', 'perna',
  'gluteo', 'abdomen', 'panturrilha', 'cardio', 'corpo_inteiro',
];
export const MUSCLE_LABELS = {
  peito: 'Peito', costas: 'Costas', ombro: 'Ombro', biceps: 'Bíceps',
  triceps: 'Tríceps', perna: 'Perna', gluteo: 'Glúteo', abdomen: 'Abdômen',
  panturrilha: 'Panturrilha', cardio: 'Cardio', corpo_inteiro: 'Corpo inteiro',
};

export const EQUIPMENT = [
  'barra', 'halter', 'maquina', 'cabo', 'peso_corporal',
  'kettlebell', 'elastico', 'anilha', 'banco', 'nenhum',
];
export const EQUIPMENT_LABELS = {
  barra: 'Barra', halter: 'Halter', maquina: 'Máquina', cabo: 'Cabo',
  peso_corporal: 'Peso corporal', kettlebell: 'Kettlebell', elastico: 'Elástico',
  anilha: 'Anilha', banco: 'Banco', nenhum: 'Nenhum',
};

export const DIFFICULTY = ['iniciante', 'intermediario', 'avancado'];
export const DIFFICULTY_LABELS = {
  iniciante: 'Iniciante', intermediario: 'Intermediário', avancado: 'Avançado',
};

export const GOALS = ['emagrecimento', 'hipertrofia', 'forca', 'condicionamento', 'saude'];
export const GOAL_LABELS = {
  emagrecimento: 'Emagrecimento', hipertrofia: 'Hipertrofia', forca: 'Força',
  condicionamento: 'Condicionamento', saude: 'Saúde',
};

// status → variante de Badge
export const TRAINER_STATUS = {
  pending: { label: 'Pendente', variant: 'warning' },
  approved: { label: 'Aprovado', variant: 'success' },
  blocked: { label: 'Bloqueado', variant: 'danger' },
  suspended: { label: 'Suspenso', variant: 'neutral' },
};
export const PACKAGE_STATUS = {
  draft: { label: 'Rascunho', variant: 'neutral' },
  pending: { label: 'Pendente', variant: 'warning' },
  published: { label: 'Publicado', variant: 'success' },
  rejected: { label: 'Rejeitado', variant: 'danger' },
};

// Tipos de cupom de desconto.
export const SEXES = ['masculino', 'feminino'];
export const SEX_LABELS = { masculino: 'Masculino', feminino: 'Feminino' };

export const TECHNIQUES = ['normal', 'superserie', 'bi_set', 'tri_set', 'dropset', 'piramide', 'rest_pause', 'circuito'];
export const TECHNIQUE_LABELS = {
  normal: 'Normal',
  superserie: 'Superserie',
  bi_set: 'Bi-set',
  tri_set: 'Tri-set',
  dropset: 'Drop set',
  piramide: 'Pirâmide',
  rest_pause: 'Rest-pause',
  circuito: 'Circuito',
};

// Descritivo de execução de cada método (mostrado ao prescrever/executar).
export const TECHNIQUE_DESCRIPTIONS = {
  normal: 'Séries tradicionais: execute as repetições, descanse o tempo indicado e repita.',
  superserie:
    'Dois exercícios em sequência, sem descanso entre eles (em geral músculos opostos). Descanse só depois de completar o par.',
  bi_set:
    'Dois exercícios para o mesmo grupo muscular, um imediatamente após o outro, sem descanso. Descanse após o segundo.',
  tri_set:
    'Três exercícios em sequência, sem descanso entre eles. Descanse apenas após o terceiro exercício.',
  dropset:
    'Ao chegar à falha, reduza a carga (20–30%) e continue sem descansar até falhar de novo. Faça 2–3 reduções na mesma série.',
  piramide:
    'Aumente a carga e diminua as repetições a cada série (crescente) — ou comece pesado e vá reduzindo a carga aumentando as repetições (decrescente).',
  rest_pause:
    'Chegue perto da falha, pause 10–20 segundos e continue com a mesma carga. Repita 2–3 vezes dentro da mesma série.',
  circuito:
    'Sequência de vários exercícios, um após o outro, com pouco ou nenhum descanso. Descanse ao final de cada volta completa.',
};

export const COUPON_TYPES = ['percent', 'fixed'];
export const COUPON_TYPE_LABELS = { percent: 'Percentual (%)', fixed: 'Valor fixo (R$)' };

export const optsFrom = (values, labels) => values.map((v) => ({ value: v, label: labels[v] || v }));

export const fmtNum = (n) => (n == null ? '—' : Number(n).toLocaleString('pt-BR'));
export const fmtMoney = (n) =>
  n == null ? '—' : `R$ ${Number(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtDate = (d) => {
  if (!d) return '—';
  const dt = new Date(d);
  return Number.isNaN(dt.getTime()) ? '—' : dt.toLocaleDateString('pt-BR');
};
